import {
    defineComponent,
    ref,
    inject
} from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "HeaderLogo",

    props: {
        webSite: {
            type: String,
            required: true,
        },
        bbcSn: {
            type: String,
            required: false,
        },
    },
    components: {},
    setup(props) {
        const compId = inject("compId", "");
        const data = ref({});
        if (props.webSite === "b2c") {
        }
        if (props.webSite === "bbc" && props.bbcSn) {
            window.AjaxPostLite(
                "getBBCHeaderInfo",
                { SN: props.bbcSn },
                function (res) {
                    if (res.MSG == null) {
                        data.value = res.DATA.enties.TBLBBC_ACCOUNT[0];
                    }
                }
            );
        }
        if (props.webSite === "b2e") {
            var DataInfo = {
                comp_id: compId.value
            };
            window.AjaxPostLite("GetHeaderForB2E", DataInfo, (res) => {
                if (res.MSG == null) {
                    var data = res.DATA.enties.B2EInfo;
                    //console.log("data", data);
                    if (data.length > 0) {
                        $(".logo-b2e-company img").attr("src", 'https://work.bwt.com.tw/' + data[0].img_url);
                    }
                } else {
                    window.ShowDialog("error", "", res.MSG);
                }

            });
        }
        return { data };
    },
    template: html`
        <div class="header-logo">
            <div
                v-if="webSite === 'b2c'"
                class="logo-b2c"
                id="b2c_logo"
            >
                <a href="/" title="百威旅遊">
                    <img
                        src="/Content/Img/Public/bestway_travel.png"
                        alt="百威旅遊"
                    />
                </a>
            </div>
            <div v-if="webSite === 'b2b'" class="logo-b2b" id="b2b_logo">
                <a href="/" title="百威旅遊同業網">
                    <img
                        src="/Content/Img/Shared/2B/logo.png"
                        alt="百威旅遊同業網"
                    />
                </a>
            </div>

            <div v-if="webSite === 'bbc'" class="logo-bbc" id="bbc_logo">
                <a href="/" :title="data.A_nm">
                    <img
                        :src="'https://'+data.A_url+'/UploadImg/Web/B2B/'+data.A_logo"
                        :alt="data.A_nm"
                    />
                </a>
            </div>
            <div v-if="webSite === 'b2e'" class="logo-b2e" id="b2e_logo">
                <a href="/" title="百威旅遊企業會員專區"><img src="/Content/Img/index/B2E/bwtB2E.png" alt="百威旅遊企業會員專區"></a>
            </div>
            <div v-if="webSite === 'b2e'" class="logo-b2e-company">
                <img>
            </div>
        </div>
    `,
});
